(() => {
  const summary = document.querySelector('[data-mayhem-toolbar-product]');
  const source = document.querySelector('[data-mayhem-pdp-summary] [data-config-price]');
  if (!summary || !source) return;
  const toolbar = summary.closest('.mayhem-setup-bar');
  const amount = summary.querySelector('[data-mayhem-toolbar-price]');
  const syncPrice = () => {
    const text = source.querySelector('strong')?.textContent || '';
    const currency = text.indexOf('$');
    amount.textContent = currency >= 0 ? text.slice(currency).trim() : text.trim();
    amount.hidden = source.hidden || !text.trim();
  };
  const syncScroll = () => {
    const scroller = toolbar.closest('.page-wrapper') || document.scrollingElement;
    const visible = Math.max(window.scrollY, scroller?.scrollTop || 0) > 80;
    summary.hidden = !visible;
    toolbar.classList.toggle('mayhem-setup-bar--product-scrolled', visible);
  };
  new MutationObserver(syncPrice).observe(source, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
  document.addEventListener('scroll', syncScroll, { passive: true, capture: true });
  window.addEventListener('pageshow', syncScroll);
  syncPrice();
  syncScroll();
})();
